import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import PageAvatarInfo from "../../../components/UI/Avatar/PageAvatarInfo/PageAvatarInfo";
import CustomMenu from "../../../components/UI/Menus/CustomMenu/CustomMenu";
import CustomTabs from "../../../components/UI/Tabs/CustomTabs/CustomTabs";
import { MenuItemEntity } from "../../../entities/UIEntities/MenuItem";
import { TabItemEntity } from "../../../entities/UIEntities/TabItem";
import { MENU_ITEMS, TABLES } from "../../../enums/Enums";
import ParkerService from "../../../hooks/useParkerService";
import Icons from "../../../resources/icons/Icons";
import Strings from "../../../resources/Strings";
import {
  handleAddCars,
  handleAddFacilityToUser,
  handleAddParkingAllocations,
  handleDeleteUser,
  handleEditGeneralDetails, 
  handleParkerActivation
} from "../../../utils/MenuUtils";
import classes from "./ParkerInfo.module.css";
import { isAllowedForActionsOnUser } from "../../../utils/UsersUtils";

const ParkerInfo = (props) => {
  const roles = useSelector((state) => state.user?.initialState)?.roles;
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const canMakeActions = isAllowedForActionsOnUser(roles, props, props?.gmtUser);
  const { getParkerDetails, getParkerHistory } = ParkerService();
  let tabs = [];

  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.EDIT_PROFILE,
      handleEditGeneralDetails,
      true,
      Icons.EDIT_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.PARKER_ACTIVATION, 
      handleParkerActivation,
      true,
      Icons.MY_PROFILE,
      false,
      {...props, selectedScope /*, activationText: MENU_ITEMS.WORKSPACE_ACCESS*/}
    ),
    new MenuItemEntity(
      MENU_ITEMS.TOKENS,
      handleAddParkingAllocations,
      true,
      Icons.TOKEN_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.ADD_CAR,
      handleAddCars,
      true,
      Icons.CAR_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.MANAGE_FACILITIES,
      handleAddFacilityToUser,
      true,
      Icons.PARKERS_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.DELETE_USER,
      handleDeleteUser,
      false,
      Icons.DELETE_ITEM,
      true,
      props?.utronUser
    ),
  ];

  const detailsTab= new TabItemEntity(
    Strings.TABS_NAMES.DEATILS,
    Strings.TABS_NAMES.DEATILS,
    getParkerDetails(props)
  );
  
  const historyTab = new TabItemEntity(
    Strings.TABS_NAMES.HISTORY,
    Strings.TABS_NAMES.HISTORY,
    getParkerHistory(props)
  );

  if(props.tableId !== TABLES.GUESTS){
    tabs.push(detailsTab);
  }
  tabs.push(historyTab);

  const onTabChange = () => {};

  const handleClose = () => {
    props.handleCloseEvent();
  };

  return (
    <div className={classes.parkerInfo}>
      <IconButton className={classes.closeButton} aria-label="closeIcon" onClick={handleClose}>
        <CloseIcon />
      </IconButton>
      <div className={classes.parkerInfoHeader}>
        <PageAvatarInfo
          name={props?.firstName !== null ? `${props.firstName} ${props.lastName}` : props?.mainCarToken?.value}
          image={props.image}
          sizeClass="big"
          hasAppBadge={props.app}
        ></PageAvatarInfo>
        {props.tableId !== TABLES.GUESTS && props.validRole && canMakeActions && <CustomMenu menuItems={menuItems}></CustomMenu>}
      </div>
      <CustomTabs
        initialTab={props.tableId === TABLES.PARKERS ? Strings.TABS_NAMES.DEATILS : Strings.TABS_NAMES.HISTORY}
        onTabChange={onTabChange}
        tabs={tabs}
      ></CustomTabs>
    </div>
  );
};

export default ParkerInfo;
